export const enum BusinessModel {
  PayPerSeat = 'pps',
  PayPerAgent = 'ppa',
}
